import { render, staticRenderFns } from "./CargoMapDetail.vue?vue&type=template&id=628dad5c&scoped=true&style=text-align%3Acenter%3B"
import script from "./CargoMapDetail.vue?vue&type=script&lang=js"
export * from "./CargoMapDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628dad5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('628dad5c')) {
      api.createRecord('628dad5c', component.options)
    } else {
      api.reload('628dad5c', component.options)
    }
    module.hot.accept("./CargoMapDetail.vue?vue&type=template&id=628dad5c&scoped=true&style=text-align%3Acenter%3B", function () {
      api.rerender('628dad5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/CargoMapDetail.vue"
export default component.exports